import React from 'react';
import PropTypes from 'prop-types';
import AuthLayout from 'layouts/AuthLayout';
import DefaultLayout from 'layouts/DefaultLayout';
import authHelper from 'helpers/auth';
import compose from 'recompose/compose';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { setPath } from 'store/actions/pathActions';
import NoAccountContainer from 'pages/Dashboard/no-account/NoAccountContainer';

const Page = (props) => {
    const {
        component: Component,
        isPublic,
        render,
        isAccountAgnostic,
        ...rest
    } = props;

    const loggedIn = authHelper.isLoggedIn();

    /**
     * Redirect user to the login page if he tries to access a private route without authentication.
     * We will store the current pathname to redirect the user that specific page after logging in.
     */
    if (!isPublic && !loggedIn) {
        const {
            location: {
                pathname,
            },
            setCurrentPath,
        } = props;

        setCurrentPath(pathname);

        return <Redirect to='/login' />;
    }

    /**
     * Redirect user to Main page if he tries to access a non private route
     * (SignIn) after being authenticated.
     */
    if (isPublic && loggedIn) {
        return <Redirect to='/' />;
    }

    const Layout = isPublic ? DefaultLayout : AuthLayout;

    if (!isAccountAgnostic && !authHelper.hasAccount()) {
        return (
            <Layout>
                <NoAccountContainer />
            </Layout>
        );
    }

    /**
     * Setting up the structure. We have two ways we want to implement this. By component prop or render prop.
     */
    if (render) {
        return <Route
            { ...rest }
            render={ (props) => {
                return (
                    <Layout>
                        { React.createElement(render, props) }
                    </Layout>
                );
            } }
        />;
    }

    return <Route
        { ...rest }
        render={ (props) => {
            return (
                <Layout>
                    <Component { ...props } />
                </Layout>
            );
        } }
    />;
};

Page.defaultProps = {
    isPublic: false,
    isAccountAgnostic: false,
};

Page.propTypes = {
    component: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.func,
    ]),
    isAccountAgnostic: PropTypes.bool,
    isPublic: PropTypes.bool,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    render: PropTypes.func,
    setCurrentPath: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentPath: (path) => {
            dispatch(setPath(path));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    )
);

export default enhance(Page);



// WEBPACK FOOTER //
// ./src/routes/Page.js